<template>
  <el-cascader
    size='mini'
    style='width:100%'
    v-model='value'
    clearable
    filterable
    :options='options'
    :props='props'
    :collapse-tags='true'
    placeholder='请选择'
    @change='selectHandle'
  >
    <template slot-scope='{ node, data }'>
      <span>{{ data.model }}</span>
      <span v-if='!node.isLeaf'> ({{ data.carModel.length }}) </span>
    </template>
  </el-cascader>
</template>

<script>
  export default {
    name: 'cascader',
    props: {
      options: {
        type: Array,
        default: () => [],
      },
      props: {
        type: Object,
        default: () => {
          return {
            value: 'id',
            label: 'model',
            children: 'carModel',
            multiple: true,
          };
        },
      },
      filed: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        preSelected: [], // 上次选中的数据
        originData: [], //  源数据平铺成一级节点
        value: [],
        isAll: false,
      };
    },
    methods: {
      judgetAllSelected(node) {
        // 判断是否是全选,也就是看已选择的选中中包不包含"全选"
        let isAllSelected = false;
        for (let i = 0; i < node.length; i++) {
          if (node[i][0] === '全选') {
            isAllSelected = true;
            break;
          }
        }
        return isAllSelected;
      },
      loopFlatData(list = [], parentNode = []) {
        list.length > 0 && list.forEach(e => {
          let pNode = [...parentNode]; // 注意这里必须是深拷贝，否则会由于引用类型赋值的是地址（指针），导致parentNode在pNode更新时，同时被更新
          if (e.carModel && e.carModel.length > 0) {
            pNode.push(e.id);// 1 11
            this.loopFlatData(e.carModel, pNode);
          } else {
            if (e.label !== '全选') {
              if (parentNode.length > 0) {
                pNode.push(e.id);
                this.originData.push({
                  ...e,
                  parentNode: pNode,
                });
              } else {
                this.originData.push(e);
              }
            }
          }
        });
      },
      loopSelectData(list, parentNode = []) {
        list.length > 0 && list.forEach(e => {
          let pNode = [...parentNode]; // 注意这里必须是深拷贝，否则会由于引用类型赋值的是地址（指针），导致parentNode在pNode更新时，同时被更新
          if (e.carModel && e.carModel.length > 0) {
            pNode.push(e.id);// 1 11
            this.loopSelectData(e.carModel, pNode);
          } else {
            if (parentNode.length > 0) {
              this.value.push([...parentNode, e.id]);
            } else {
              this.value.push([e.id]);
            }
          }
        });
      },
      checkIsAddAllSelected() {
        let list = this.options; // 原始数据列表
        if (this.originData.length === 0) {
          this.loopFlatData(list); // 把所有的父子级平铺成一个一级列表
        }
        let origin = this.originData;
        let now = [...this.value].filter(item => item);
        if (this.isAll && origin.length > now.length) {
          this.value = this.value.filter(item => item[0] !== '全选'); // 移除全选选项
          this.isAll = false;
        } else {
          if (now.length === origin.length) {
            if (this.value[0] && this.value[0][0] !== '全选') {
              // 非全选时, 如果有之前选过全选,要把全选过滤掉
              this.value = [['全选'], ...this.value.filter(item => item[0] !== '全选')];
              this.isAll = true;
            }
          } else {
            // 如果不是全选状态，确保没有全选选项
            this.value = this.value.filter(item => item[0] !== '全选');
            this.isAll = false;
          }
        }
      }
      ,
      async selectHandle(node = []) {
        this.value = [];
        let list = this.options;
        let current = [];
        if (node.length >= this.preSelected.length) {
          // 选中某项
          let keys = this.preSelected.map(item => JSON.stringify(item));
          current = node.filter(item => !keys.includes(JSON.stringify(item)));
        } else {
          // 取消选中
          let keys = node.map(item => JSON.stringify(item));
          current = this.preSelected.filter(item => !keys.includes(JSON.stringify(item)));
        }
        const currentValue = current.length > 0 ? current[0][0] || '' : '';
        if (currentValue === '全选') {
          if (this.judgetAllSelected(node)) {
            // 全选操作
            this.loopSelectData(list);
            this.isAll = true;
          } else {
            // 取消全选操作，需要清空所有选项
            this.value = [];
            this.isAll = false;
          }
        } else {
          // 处理非全选的选项
          this.value = node.filter(item => item[0] !== '全选');
          this.isAll = false; // 取消全选时，isAll 应该设置为 false
        }
        this.checkIsAddAllSelected();
        this.preSelected = this.value;
        this.changeHandle();
      },
      changeHandle() {
        // 这里是处理成自己需要的数据格式, 需要把全选的这一选项过滤掉
        // 原始选择的数据格式[['全选'], ['1', '11'], ['2', '21'],...]
        // console.log('changeHandle: ', this.value);
        this.$emit('getValue', this.filed, this.value, this.isAll);
      },
    },
  };
</script>

<style scoped>

</style>
